// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".precise-price-app .icon--3-Iya{width:var(--icon-size);height:var(--icon-size);display:inline-flex;box-sizing:border-box}.precise-price-app .icon_wrapped--nRRdi{justify-content:center;align-items:center;background-color:var(--icon-background-color);border-radius:var(--icon-wrapper-radius,50%);padding:var(--icon-wrapper-padding,7px)}", ""]);
// Exports
exports.locals = {
	"icon": "icon--3-Iya",
	"iconWrapped": "icon_wrapped--nRRdi"
};
module.exports = exports;
